import { Key } from "react";

import { Text } from "../../../../foundations/typography/Text";
import { DropdownMenu } from "../../../dropdown-menu/DropdownMenu";
import { MenuItem } from "../../../dropdown-menu/assets/MenuItem";

export interface InputGroupDropDownProps {
  items: { value: string; display: string }[];
  selectedKey?: string;
  onSelectionChange?: (value: Key) => void;
  testID?: string;
}

export function InputGroupDropDown({
  items: options,
  selectedKey,
  onSelectionChange,
  testID = "input-group-drop-down",
}: InputGroupDropDownProps) {
  return (
    <DropdownMenu
      onItemAction={(id) => onSelectionChange?.(id)}
      label={selectedKey}
      testID={testID}
    >
      {options.map((option) => (
        <MenuItem id={option.value} key={option.value}>
          <Text style="input/text-field">{option.display}</Text>
        </MenuItem>
      ))}
    </DropdownMenu>
  );
}
